import { render, staticRenderFns } from "./HeaderVacation.vue?vue&type=template&id=47f5b776&scoped=true&"
import script from "./HeaderVacation.vue?vue&type=script&lang=js&"
export * from "./HeaderVacation.vue?vue&type=script&lang=js&"
import style0 from "./HeaderVacation.vue?vue&type=style&index=0&id=47f5b776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5b776",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VRow})
